import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { Modal, ResolvableModal} from '@softline/ui-core';
import { TicketComment } from '../../data/ticket-comment.model';
import { Ticket } from '../../data/ticket.model';
import { authorizationFn } from '@softline/auth';
import { CommonModule } from '@angular/common';
import { SOFTLINE_PERMISSION_TICKET_EDITOR } from '../../ticket.shared';

import { CheckboxComponent } from '@softline/ui-core';
import { MultilineInputComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'lib-create-comment',
  imports: [CommonModule, ReactiveFormsModule,
    CheckboxComponent,
    MultilineInputComponent,
    TranslatePipe],
  templateUrl: './create-comment.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./create-comment.component.css'] })
export class CreateCommentComponent extends ResolvableModal<any> implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private readonly isAuthorized = authorizationFn();

  readonly isEditor = this.isAuthorized(SOFTLINE_PERMISSION_TICKET_EDITOR);

  ticket = input.required<Ticket>();

  form = this.fb.group({
    comment: ['', Validators.required],
    internal: [false] });

  ngOnInit(): void {}

  onSubmit(): void {
    const comment = this.form.value.comment;
    this.resolve({
      ticketId: +this.ticket()?.id,
      creationDate: new Date(Date.now()).toISOString(),
      internal: this.form.value.internal,
      text: comment });
  }
}
